import { useEffect, useRef, useState } from "react";
import SectionHeader from "../eventsExperiences/SectionHeader";
// Placeholder photos until the final images are ready.
import campaignImg from "../../assets/images/webp/event_slider1.jpg";
import launchImg from "../../assets/images/webp/event_slider2.jpg";
import occasionImg from "../../assets/images/webp/event_theme1.jpg";
import liveImg from "../../assets/images/webp/event_entertainment3.jpg";
import collabImg from "../../assets/images/webp/event_entertainment1.jpg";

const USES = [
  { title: "Brand Campaigns", image: campaignImg },
  { title: "Product Launches", image: launchImg },
  { title: "Weddings & Private Occasions", image: occasionImg },
  { title: "Live Performances", image: liveImg },
  { title: "Brand Collaborations", image: collabImg },
];

const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// Like the reference: the cards start as a stack, fan out in 3D, then settle
// into a row with their titles, once the section scrolls into view.
const CelebUses = () => {
  const [phase, setPhase] = useState(() => (reducedMotion() ? "row" : "stack"));
  const deck = useRef(null);

  useEffect(() => {
    if (phase !== "stack") return undefined;
    const timers = [];
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        timers.push(setTimeout(() => setPhase("fan"), 300), setTimeout(() => setPhase("row"), 1700));
      },
      { threshold: 0.5 }
    );
    observer.observe(deck.current);
    return () => {
      observer.disconnect();
      timers.forEach(clearTimeout);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="ee-section cm-possibilities">
      <div className="container">
        <SectionHeader
          eyebrow="Possibilities"
          title="What can this"
          accent="look like?"
          intro="From campaigns to celebrations, we create celebrity collaborations across formats."
        />
        <div className="cm-deck" ref={deck} data-phase={phase}>
          {USES.map(({ title, image }, i) => (
            // --i: position from the centre card; --d: how far out (staggers the moves).
            <article className="cm-use" key={title} style={{ "--i": i - 2, "--d": Math.abs(i - 2), zIndex: 5 - Math.abs(i - 2) }}>
              <div className="cm-use-card">
                <img src={image} alt="" loading="lazy" />
                <span className="cm-use-num">0{i + 1}</span>
              </div>
              <h3>{title}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CelebUses;
